import { render } from "./profile-othersetting.vue?vue&type=template&id=f15e0df6"
import script from "./profile-othersetting.vue?vue&type=script&lang=js"
export * from "./profile-othersetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__